import React from 'react';

export const CustomDivider: React.FunctionComponent<{ style?: React.CSSProperties }> = function ({
    style,
}) {
    return <hr style={{ opacity: '0.2', ...style }} />;
};
